import constants from '../qti/Constants';
import settingsReader from '../store/readHelpers/SettingsReader';

// Known postfixes for drawing-related response identifiers
export const DRAWING_POSTFIXES = [
    '_jsonId',
    '_fileName',
    '_fileType',
    '_fileSize',
    '_drawingBase64',
    '_jsonData',
    '_pendingSync',
    '_fileURI',
    '_jsonDataURI',
];

// Checks if an identifier is a drawing response identifier.
export default function isDrawingResponseIdentifier(identifier) {
    if (typeof identifier !== 'string') {
        return false;
    }
    if (identifier.includes('_canvasbg_')) {
        return false;
    }
    return DRAWING_POSTFIXES.some(postfix => identifier.endsWith(postfix));
}

// Checks if drawing is enabled for preloading purposes.
export function isDrawingEnabledForPreloading(question) {
    if (!settingsReader.isCandidateDrawingOptionEnabled()) {
        return false;
    }

    if (question?.responseModels?.some(model => model.type === constants.interactionType.DRAWING_INTERACTION)) {
        return true;
    }

    if (question?.itemBody?.includes('<drawingInteraction')) {
        return true;
    }

    return false;
}

// Determines if an offline data value should be cleared when serializing item results.
export function shouldClearOfflineDataValue(identifier, includeOfflineData) {
    if (includeOfflineData) {
        return false;
    }
    if (typeof identifier !== 'string') {
        return false;
    }
    return (
        identifier.includes('_canvasbg_') ||
        identifier.endsWith('_drawingBase64') ||
        identifier.endsWith('_jsonData') ||
        identifier.endsWith('_pendingSync')
    );
}

// Restores missing locked background elements into a candidate scene (by element id).
export function restoreLockedBackgroundElements(candidateElements = [], backgroundElements = []) {
    const candidateIds = new Set(
        candidateElements
            .filter(el => el && !el.isDeleted && el.id)
            .map(el => el.id)
    );

    const missingLocked = [];
    const missingIds = new Set();

    for (const bgEl of backgroundElements) {
        if (bgEl && !bgEl.isDeleted && bgEl.locked === true && bgEl.id) {
            if (!candidateIds.has(bgEl.id)) {
                missingLocked.push(bgEl);
                missingIds.add(bgEl.id);
            }
        }
    }

    if (missingLocked.length === 0) {
        return null;
    }

    return [
        ...missingLocked,
        ...candidateElements.filter(el => !missingIds.has(el?.id)),
    ];
}
